import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// users
import user1 from "../../../assets/images/users/avatar-blank.png"
import { get } from "helpers/api_helper";
import { API_URL } from "helpers/url_helper";

const setProfile = (data) => ({
  type: "SET_PROFILE",
  payload: data
})

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  const [username, setusername] = useState("Admin")
  const [profile, setProfile] = useState({});
  const [avatar,setAvatar] = useState(``)
  const [avatarErr,setAvatarErr] = useState(false)

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"))
        setusername(obj?.full_name || "User")
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"))
        setusername(obj?.full_name || "User")
      }
    }
  }, [props.success])

  const getProfile = async ()=>{
    let response = await get('/user/token/data')
    const data = response?.data[0]
    setProfile( data || {});
    setAvatar(`${API_URL + `/` + data.photo_profile || {}}`)

    props.setProfile(data) // dispatch
  }

  useEffect(()=>{
    getProfile();
  },[])

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          {avatar != '' ?
            <img
              className="rounded-circle header-profile-user"
              src={avatarErr ? user1 : avatar}
              onError={()=> setAvatarErr(true)}
              alt="Header Avatar"
            />
          : null }
          <span className="d-none d-xl-inline-block ms-2 me-1">{profile?.full_name || "User"}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block"/>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag="a" href="/profile">
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1"/>
            {props.t("Profile")}{" "}
          </DropdownItem>
          <div className="dropdown-divider"/>
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger"/>
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
  setProfile: PropTypes.func.isRequired,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, { setProfile })(withTranslation()(ProfileMenu))
)
